import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthStateService } from '../services/auth-state.service';

const PUBLIC_URL_FRAGMENTS = ['/mobile/login', '/mobile/recover_account'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthStateService);

  const isPublic = PUBLIC_URL_FRAGMENTS.some((fragment) => req.url.includes(fragment));
  if (isPublic) {
    return next(req);
  }

  const token = auth.token();
  if (!token) {
    return next(req);
  }

  const cloned = req.clone({
    setHeaders: {
      Authorization: token
    },
  });

  return next(cloned);
};
